import React, { useEffect, useState } from 'react';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './PercentLoaderIcon.scss';
const rootClassName = 'percent-loader-icon';

export const PercentLoaderIcon = (props: {
  value?: string | number;
  hideCheck?: boolean;
  indefinido?: boolean;
}) => {
  const getStrokeDashOffset = (): number => {
    const v = props.indefinido ? '25' : props.value ?? '';
    return 264 - (264 * parseInt(String(v))) / 100;
  };

  const [sdo, setSdo] = useState(
    props.indefinido ? getStrokeDashOffset() : 264
  );

  useEffect(() => {
    setSdo(getStrokeDashOffset());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value, props.indefinido]);

  return (
    <svg
      className={getMergedClassNames([
        rootClassName,
        props.indefinido ? 'indefinido' : '',
      ])}
      viewBox='0 0 100 100'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='50' cy='50' r='42' />
      <circle
        cx='50'
        cy='50'
        r='42'
        strokeDashoffset={sdo}
        stroke='currentColor'
      />
      {!props.indefinido && !props.hideCheck ? (
        <path
          d='M710.428,339.1l12.762,12.454,22.376-25.148'
          fill='none'
          strokeWidth='5'
          strokeDasharray='52'
          strokeDashoffset={
            parseInt(String(props.value ?? '')) === 100 ? 0 : 52
          }
          stroke='currentColor'
        />
      ) : undefined}
    </svg>
  );
};
